import { Button, Modal } from "react-bootstrap";
import { FaCrown } from "react-icons/fa";

export default function UserMakeAdminModal({
    userEmail,
    show,
    onProceed,
    onCancel,
}) {
    return (
        <Modal show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaCrown className="me-2" style={{ marginTop: "-2px" }} />
                    Make Admin
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                You are about to make user <strong>{userEmail}</strong> an
                Admin. Are you sure you want to proceed?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={onCancel}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={onProceed}>
                    <FaCrown className="me-2" style={{ marginTop: "-2px" }} />
                    Proceed
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
